module.exports = __webpack_public_path__ + "static/img/server.60385da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/server.png
// module id = o8+2
// module chunks = 0